<template>
  <div>
    <div class="home">
      <el-row>
        <h1 style="margin-top:180px;">嘌呤含量查询</h1>
      </el-row>
      <el-row class="demo-autocomplete">
        <el-col :span="24">
        <i class="el-icon-search"></i>
        <el-autocomplete style="width:80%"
        v-model="inputa"
        :fetch-suggestions="querySearch"
        placeholder="请输入您想查询嘌呤含量的食物"
        :trigger-on-focus="true"
        @select="handleSelect"></el-autocomplete>
        </el-col>
      </el-row>
    </div>
    <div class="content" v-show="isshow">
      <el-row>
        <el-col :span="18" offset=3><div class="grid-content bg-purple"><h2 class="crumb">{{food.pcategory}}</h2></div></el-col>
      </el-row>
      <el-row>
        <el-col :span="18" offset=3 style="border:1px solid #ccc">
          <h3>{{food.pname}}</h3>
          <h4>嘌呤含量：{{food.phl}}mg/100g </h4>
          <h4>饮食建议：{{food.padv}} </h4>
          <h4>别名：{{food.palias}} </h4>
          <h4><a href="#">》》》食物详情》》》</a></h4>
        </el-col>
      </el-row>
    </div>
    <div class="content">
        <el-row>
            <el-col :span="18" offset=3><div class="grid-content bg-purple"><h2 class="crumb">医生建议</h2></div></el-col>
        </el-row>
        <el-row style="margin-bottom: 30px;">
            <el-col :span="18" offset=3 style="border:1px solid #ccc">
                <h4>① 痛风急性发作期，每日嘌呤摄入量控制在100－150mg之间。</h4>
                <h4>② 痛风稳定期可适当放松，每日嘌呤摄入量控制在300mg左右。</h4>
                <h4>③ 高尿酸血症诊断标准：男性大于7mg/dl，女性大于6mg/dl。</h4>
                <h4>》》》<router-link to="/Diagnose">痛风诊断</router-link> 》》》</h4>
                <h4>》》》<router-link to="/Habits">生活习惯检查</router-link> 》》》</h4>
            </el-col>
        </el-row>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'home',
  data () {
    return {
      inputa: '',
      food: {}
    }
  },
  methods: {
    querySearch (queryString, cb) {
      console.log(queryString)
      console.log('food:' + this.food.pname)
      axios({
        method: 'get',
        url: 'http://api.lokijwp.cn/search/' + queryString
      }).then(({ data }) => {
        console.log('then')
        console.log(data)
        for (var i = 0; i < data.length; i++) {
          data[i].value = data[i].pname
          data[i].key = data[i].pid
        }
        cb(data)
      })
    },
    handleSelect (item) {
      console.log('select')
      this.food = item
    }
  },
  computed: {
    isshow: function () {
      return JSON.stringify(this.food) !== '{}'
    }
  }
}
</script>

<style>
body {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
#App {
  width: 100%;
  margin:0 0;
  padding:0 0;
}
.home {
  height: 400px;
  background-size: cover;
  position: relative;
  background:url('../assets/food_bg_1.jpg');
  background-repeat: no-repeat;
  background-position: center center;
}
.home h1{color:#eee;letter-spacing:12px;font-family: "微软雅黑";}

.content{
  width:100%;
}
.content .crumb{
  text-align:left;
  margin: 26px 0;
  font-size: 14px;
  padding-left: 5px;
  border-left: 5px solid #61cc73;
}
.content h3{
  border-bottom:1px solid green;
  background-color: #efefef;
  font-size:18px;
  line-height:30px;
  text-align:left;
  padding-left:20px;
  margin: 0 0;
}
.content h4{
  border-bottom:1px solid #eee;
  font-size:16px;
  line-height:30px;
  text-align:left;
  padding-left:20px;
  margin: 0 0;
  font-weight: 300;
}

.el-icon-search{
  margin-right: -15px;
  position: relative;
  z-index: 999;
  font-size: 12px;
  color: #ccc;
}
.message-check-2{
  width: auto !important;
}
.message-check{
  width: auto !important;
}
</style>
